var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9311 10.5736V10.5736C18.0525 10.8421 18.0054 11.1568 17.8107 11.378L9.56685 20.753V20.753C9.29327 21.0637 8.81961 21.0938 8.50891 20.8202C8.27642 20.6155 8.19381 20.2888 8.301 19.9982L10.5525 13.8825H6.75585V13.8825C6.34164 13.8822 6.00607 13.5462 6.00635 13.132C6.00647 12.9498 6.07287 12.774 6.19316 12.6372L14.4374 3.26218V3.26218C14.7109 2.95142 15.1845 2.9212 15.4953 3.19469C15.7279 3.39943 15.8106 3.72622 15.7032 4.01694L13.4516 10.1325H17.2482V10.1325C17.5428 10.1324 17.81 10.3051 17.9311 10.5736V10.5736Z",
    stroke: "#B8BEC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.c65b27f88ba1b10ede7ec7126ec77155.svg";
export { ForwardRef as ReactComponent };